document.addEventListener('DOMContentLoaded', () => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('cartOpen') === 'true' && typeof window.opusOpen === 'function') {
        setTimeout(() => {
            window.opusOpen();
        }, 200);

        urlParams.delete('cartOpen');
        const newUrl = `${window.location.pathname}${urlParams.toString() ? '?' + urlParams.toString() : ''}`;
        window.history.replaceState({}, document.title, newUrl);
    }
});